import multiRequest from '../shared/multiRequest';

const getContactData = () => {
  return multiRequest([
    {
      url: 'contentful/contact',
      method: 'GET',
    },
  ]);
};

const ContactService = {
  getContactData,
};

export default ContactService;
